import { FC, useCallback, useRef, useState } from "react";
import styled from "styled-components";
import useSmoothAnchor from "lib/hooks/useSmoothAnchor";
import Logo from "components/official/header/Logo";
import Hamburger from "components/gonzo/parts/Hamburger";
import { CSSTransition } from "react-transition-group";

const Header: FC = () => {
  const [opened, setOpened] = useState(false);
  const toggleMenu = useCallback(() => setOpened(!opened), [opened, setOpened])
  const closeMenu = useCallback(() => setOpened(false), [setOpened])
  useSmoothAnchor("news");
  useSmoothAnchor("campaign");
  useSmoothAnchor("illustration");
  useSmoothAnchor("crowdfunding");
  useSmoothAnchor("exhibition");
  useSmoothAnchor("message");
  const ref = useRef<HTMLElement>(null)
  return (
    <Root>
      <StyledLogo />
      <Hamburger opened={opened} onToggle={toggleMenu} />
      <CSSTransition nodeRef={ref} in={opened} timeout={160} classNames="fade">
        <TocNav ref={ref}>
          <Toc>
            <TocItem>
              <Anchor href="#news" onClick={closeMenu}>ニュース</Anchor>
            </TocItem>
            <TocItem>
              <Anchor href="#campaign" onClick={closeMenu}>キャンペーン</Anchor>
            </TocItem>
            <TocItem>
              <Anchor href="#illustration" onClick={closeMenu}>お祝いイラスト</Anchor>
            </TocItem>
            <TocItem>
              <Anchor href="#crowdfunding" onClick={closeMenu}>クラウドファンディング</Anchor>
            </TocItem>
            <TocItem>
              <Anchor href="#exhibition" onClick={closeMenu}>オンライン展示会</Anchor>
            </TocItem>
            <TocItem>
              <Anchor href="#message" onClick={closeMenu}>ご挨拶</Anchor>
            </TocItem>
          </Toc>
        </TocNav>
      </CSSTransition>
    </Root>
  )
}
export default Header;

const SP_HEIGHT = "50px";

const Root = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  background-color: #000;
  @media screen and (max-width: 960px) {
    height: ${SP_HEIGHT};
    padding: 7px 10px 7px;
  }
  @media screen and (min-width: 961px) {
    height: 70px;
    padding: 14px 40px 14px;
  }
`;

const StyledLogo = styled(Logo)`
  @media screen and (max-width: 960px) {
    padding: 6px 0;
  }
`;
const TocNav = styled.nav`
  flex-basis: 680px;
  @media screen and (max-width: 960px) {
    background-color: rgba(10, 10, 10, 0.8);
    position: absolute;
    top: ${SP_HEIGHT};
    left: 0;
    height: calc(100vh - 50px);
    width: 100%;
    z-index: 4;
    opacity: 0;
    visibility: hidden;
    transition: opacity .4s;
    &.fade-enter-active {
      opacity: 1;
      visibility: visible;
    }
    &.fade-enter-done {
      opacity: 1;
      visibility: visible;
    }
    &.fade-exit-active {
      opacity: 0;
      visibility: visible;
    }
    &.fade-exit-done {
      opacity: 0;
      visibility: hidden;
    }
  }
`;

const Toc = styled.ul`
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (min-width: 961px) {
    display: flex;
    justify-content: space-between;
    align-content: baseline;
  }
`;

const TocItem = styled.li`
  @media screen and (max-width: 960px) {
    padding: 20px;
  }
`;

const Anchor = styled.a`
  color: white;
  cursor: pointer;
`;
